import EventBus       from '@/shared/services/event_bus';
import AbilityService from '@/shared/services/ability_service';
import Session from '@/shared/services/session';
import Records from '@/shared/services/records';
import openModal from '@/shared/helpers/open_modal';
import Flash from '@/shared/services/flash';
import BookmarkService from '@/shared/services/bookmark_service';

export default new class CommentService {
  actions(comment, vm, topic_item) {
    const isOwnComment = comment.authorId === Session.userId;
    return {
      ...BookmarkService.actions(comment),

      react: {
        dock: 1,
        canPerform() {
          const topic = comment.topic();
          return !comment.discardedAt && topic && AbilityService.canAddReaction(topic);
        }
      },

      untranslate_comment: {
        icon: 'mdi-translate',
        name: 'common.action.original',
        dock: 3,
        canPerform() {
          return AbilityService.canUntranslate(comment);
        },
        perform() {
          return comment.translationId = null;
        }
      },

      translate_comment: {
        icon: 'mdi-translate',
        name: 'common.action.translate',
        dock: 3,
        canPerform() {
          return AbilityService.canTranslate(comment);
        },
        perform() {
          return Records.translations.addTo(comment, Session.user().locale);
        }
      },

      notification_history: {
        name: 'action_dock.notification_history',
        icon: 'mdi-alarm-check',
        menu: true,
        perform() {
          return openModal({
            component: 'AnnouncementHistory',
            props: {
              model: comment
            }
          });
        },
        canPerform() {
          const topic = comment.topic();
          return !comment.discardedAt &&
                 topic &&
                 topic.membersInclude(Session.user());
        }
      },

      reply_to_comment: {
        name: 'common.action.reply',
        icon: 'mdi-reply',
        dock: 3,
        canPerform() { return AbilityService.canRespondToComment(comment); },
        perform() {
          const topic = comment.topic();
          if (topic_item.depth === (topic ? topic.maxDepth : 3)) {
            return EventBus.$emit('toggle-reply', comment, topic_item.parentId);
          } else {
            return EventBus.$emit('toggle-reply', comment, topic_item.id);
          }
        }
      },

      edit_comment: {
        name: 'common.action.edit',
        icon: 'mdi-pencil',
        dock: 3,
        canPerform() { return !comment.discardedAt && comment.authorIs(Session.user()) && AbilityService.canEditComment(comment); },
        perform() {
          return openModal({
            component: 'EditCommentForm',
            maxWidth: 800,
            props: {
              comment: comment.clone()
            }
          });
        }
      },

      admin_edit_comment: {
        name: 'common.action.edit',
        icon: 'mdi-pencil',
        menu: true,
        canPerform() {
          return !comment.authorIs(Session.user()) && AbilityService.canEditComment(comment);
        },
        perform() {
          return openModal({
            component: 'EditCommentForm',
            props: {
              comment: comment.clone()
            }
          });
        }
      },

      show_history: {
        name: 'action_dock.edited',
        icon: 'mdi-history',
        dock: 3,
        canPerform() {
          const topic = comment.topic();
          return comment.edited() && (!comment.discardedAt ||
                               (topic && topic.adminsInclude(Session.user())));
        },
        perform() {
          return openModal({
            component: 'RevisionHistoryModal',
            props: {
              model: comment
            }
          });
        }
      },

      discard_comment: {
        name: 'common.action.discard',
        icon: 'mdi-delete-outline',
        menu: true,
        canPerform() { return AbilityService.canDiscardComment(comment); },
        perform() { return comment.discard(); }
      },

      undiscard_comment: {
        name: 'common.action.restore',
        icon: 'mdi-delete-restore',
        menu: true,
        canPerform() { return AbilityService.canUndiscardComment(comment); },
        perform() { return comment.undiscard(); }
      },

      delete_comment: {
        name: 'common.action.delete',
        icon: 'mdi-delete',
        menu: true,
        canPerform() { return AbilityService.canDeleteComment(comment); },
        perform() {
          return openModal({
            component: 'ConfirmModal',
            props: {
              confirm: {
                submit() { return comment.destroy().then(() => window.location.reload()); },
                text: {
                  title: 'delete_comment_dialog.title',
                  helptext: 'delete_comment_dialog.question',
                  confirm: 'delete_comment_dialog.title',
                  flash: 'comment_form.messages.destroyed'
                }
              }
            }
          });
        }
      }
    };
  }
};
